import React from 'react';
import PropTypes from 'prop-types';
import WixSDK from 'shared/utils/wix-sdk';
import autobind from 'core-decorators/lib/autobind';
import { connect } from 'react-redux';
import { pauseVideo } from 'widget/redux/client/actions/player/change-playback-status';
import { isVideoPlayingOptimistic } from 'widget/selectors/video-playback-status';

@connect(
  state => ({
    isVideoPlaying: isVideoPlayingOptimistic(state),
  }),
  {
    pauseVideo,
  },
)
export class ViewerObserver extends React.Component {
  static propTypes = {
    isVideoPlaying: PropTypes.bool.isRequired,
    pauseVideo: PropTypes.func.isRequired,
  };

  componentDidMount() {
    WixSDK.addEventListener(
      WixSDK.Events.PAGE_NAVIGATION,
      this.stopPlaybackOnPageChange,
    );
  }

  componentWillUnmount() {
    WixSDK.removeEventListener(
      WixSDK.Events.PAGE_NAVIGATION,
      this.stopPlaybackOnPageChange,
    );
  }

  @autobind
  stopPlaybackOnPageChange({ wasAppOnPage }) {
    if (wasAppOnPage && this.props.isVideoPlaying) {
      this.props.pauseVideo();
    }
  }

  render() {
    return null;
  }
}
